export default {
  MASTER: 'master',
  COACHING: 'coaching',
};
